import React from 'react';
import {colors} from '../utils/colors';

const Titulo = props => (
	<div>
   <h1 style={{ fontWeight: 900,
   fontSize: 'calc(3vw + 1em)',
   fontStyle: 'italic',
   lineHeight: '1.2em',
   color: `${colors.main}`,
   marginTop: '1.5em',
   marginBottom: 0}}>
      {props.contenido}
   </h1>
	</div>
);

export default Titulo;



// WEBPACK FOOTER //
// ./src/components/Titulo.js